var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitiustechLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "url(#pattern0_9_681)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_9_681",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9_681",
    transform: "scale(0.00666667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9_681",
    width: 150,
    height: 150,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAIAAACzY+a1AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAlqADAAQAAAABAAAAlgAAAAAXS0ggAAAEYklEQVR4Ae2dP2tTcRSGe0MSlzTQCNahg0u2Kuhi+wEcBJ0d1A/hJDg6OPsdBAXBwcnJ2Xb1zyaKUBBbqqJ2SGJzvdfpnNwMUk5yfOHJdM4lOefN89zc8ZeiLMsVXsoE2lX4e3d/fPzwO/db3H/QHw7rMPY1nZY3b3yzV1Lqx08HRTG7+fD75OVucra1fvvK9qCm9ub15N3bZIW/fs55GFQPiN2dySy8pfdVjKbC8WS692W09CxuYZWh6lvuGo0gARQKSvORUeh5CHYoFJTmI6PQ8xDsUCgozUdGoech2KFQUJqPjELPQ7BDoaA0HxmFnodgh0JBaT4yCj0PwQ6FgtJ8ZBR6HoIdCgWl+cgo9DwEOxQKSvORUeh5CHYoFJTmI6PQ8xDsUCgozUdGoech2KFQUJqPjELPQ7BDoaA0HxmFnodgh0JBaT4yCj0PwQ6FgtJ8ZBR6HoIdCgWl+cgo9DwEOxQKSvORUeh5CHYoFJTmI6PQ8xDsUCgozUdGoech2KFQUJqPjELPQ7BDoaA0H7mojtGrDvA6OppzfpZ/52K7zc12b3XO/bTzarzYxf8wfWu723zXaDzd/5qcrdtprZ/u1gqb+bgiRGDOjS+UnqgVARTK3wYoRKE8AfkvwK8QhfIE5L9AfbDz9auH6Qc7P3s+uHipM4NzWpYPH+3NXFx+e+f2RtE42fnzwejJi/3lh7Ebzww6t66d5UFqmUjWKJTUZkOj0NKQrFEoqc2GRqGlIVmjUFKbDY1CS0OyRqGkNhsahZaGZI1CSW02NAotDckahZLabGgUWhqSNQoltdnQKLQ0JGsUSmqzoVFoaUjWKJTUZkOj0NKQrFEoqc2GRqGlIVmjUFKbDY1CS0OyRqGkNhsahZaGZI1CSW02NAotDckahZLabGgUWhqSNQoltdnQKLQ0JGsUSmqzoVFoaUjWKJTUZkOj0NKQrFEoqc2GRqGlIVmjUFKbDY1CS0OyRqGkNhsahZaGZI1CSW02NAotDcmag50ltdnQ/AotDckahZLabGgUWhqSNQoltdnQKLQ0JGsUSmqzoeuDnfnDH0ukWQv84c9/ezb38XE5PJd8/nVl9P2n9VbjacXZ3M17nSsnJNC4u044h4+lEUBhGvqoxSiMIpk2B4Vp6KMWozCKZNocFKahj1qMwiiSaXNQmIY+ajEKo0imzUFhGvqoxSiMIpk2B4Vp6KMWozCKZNocFKahj1qMwiiSaXNQmIY+ajEKo0imzUFhGvqoxSiMIpk2B4Vp6KMWozCKZNocFKahj1qMwiiSaXNQmIY+ajEKo0imzUFhGvqoxSiMIpk2B4Vp6KMWozCKZNocFKahj1qMwiiSaXNQmIY+ajEKo0imzUFhGvqoxSiMIpk2B4Vp6KMWozCKZNocFKahj1qMwiiSaXNQmIY+ajEKo0imzanPYDt/odPrFWkR/i7urc4JUBQrl7c6ucGq7VWM5qvbaW2sn2peX+aVtX6tj7O5l8l8Ibv+AOKlf/VoLPG+AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitiustechLogo);
export default __webpack_public_path__ + "static/media/citiustech-logo.5e07e7f0e827baf5024a37fee821d1b6.svg";
export { ForwardRef as ReactComponent };